import React from "react";

export const IMAGE_WIDTH_PRESETS = [
    { label: "Small", width: 120 },
    { label: "Medium", width: 200 },
    { label: "Large", width: 280 },
    { label: "XL", width: 400 },
];

export function applyImageDisplayWidth(img, widthPx) {
    if (!img) return;
    const width = Math.min(600, Math.max(60, parseInt(widthPx, 10) || 200));
    img.style.width = `${width}px`;
    img.style.maxWidth = `${width}px`;
    img.style.height = "auto";
    img.setAttribute("width", String(width));
    img.removeAttribute("height");
}

/** Shrink pasted/uploaded signature images so SMTP send stays fast and reliable */
export function compressImageDataUrl(dataUrl, maxWidth = 420, quality = 0.82) {
    return new Promise((resolve) => {
        if (!dataUrl || !String(dataUrl).startsWith("data:image/")) {
            resolve(dataUrl || "");
            return;
        }
        const img = new Image();
        img.onload = () => {
            try {
                const naturalW = img.naturalWidth || img.width || maxWidth;
                const naturalH = img.naturalHeight || img.height || maxWidth;
                const scale = Math.min(1, maxWidth / naturalW);
                const w = Math.max(1, Math.round(naturalW * scale));
                const h = Math.max(1, Math.round(naturalH * scale));
                const canvas = document.createElement("canvas");
                canvas.width = w;
                canvas.height = h;
                const ctx = canvas.getContext("2d");
                if (!ctx) {
                    resolve(dataUrl);
                    return;
                }
                ctx.drawImage(img, 0, 0, w, h);
                resolve(canvas.toDataURL("image/jpeg", quality));
            } catch {
                resolve(dataUrl);
            }
        };
        img.onerror = () => resolve(dataUrl);
        img.src = dataUrl;
    });
}

export function getImageDisplayWidth(img) {
    if (!img) return 200;
    const fromStyle = parseInt(String(img.style.width || img.style.maxWidth || "").replace("px", ""), 10);
    if (Number.isFinite(fromStyle) && fromStyle > 0) return fromStyle;
    const fromAttr = parseInt(img.getAttribute("width"), 10);
    if (Number.isFinite(fromAttr) && fromAttr > 0) return fromAttr;
    return img.naturalWidth > 0 ? Math.min(img.naturalWidth, 280) : 200;
}

export default function ImageResizeBar({ width, onWidthChange, onClose, label = "Image size" }) {
    if (!onWidthChange) return null;

    return (
        <div className="crm-image-resize-bar">
            <span className="crm-image-resize-bar-label">
                <i className="bi bi-aspect-ratio me-1" aria-hidden="true"></i>
                {label}: <strong>{width}px</strong>
            </span>
            <div className="crm-image-resize-bar-presets">
                {IMAGE_WIDTH_PRESETS.map((preset) => (
                    <button
                        key={preset.width}
                        type="button"
                        className={width === preset.width ? "active" : ""}
                        onClick={() => onWidthChange(preset.width)}
                    >
                        {preset.label}
                    </button>
                ))}
            </div>
            <input
                type="range"
                min="60"
                max="600"
                step="10"
                value={width}
                onChange={(e) => onWidthChange(parseInt(e.target.value, 10))}
                aria-label="Image width"
            />
            {onClose && (
                <button type="button" className="crm-image-resize-bar-close" onClick={onClose} title="Done">
                    <i className="bi bi-check-lg"></i>
                </button>
            )}
        </div>
    );
}
